import { Link } from "react-router-dom";

import { Banner } from "@/components/ui/banner";
import { Button } from "@/components/ui/button";

// The /403 surface, reused by RoleGuard when an authenticated user lacks the role
// for a route. Distinct from /sign-in (which is for UNauthenticated users).
export function ForbiddenPage() {
  return (
    <section className="flex flex-col gap-4">
      <h1 className="display-xs">Insufficient permissions</h1>
      <Banner variant="warn" title="You don't have access to this area">
        <p>Your role doesn't permit this page. If you believe this is a mistake, contact your administrator.</p>
      </Banner>
      <div>
        <Button asChild variant="secondary">
          <Link to="/">Back to your workspace</Link>
        </Button>
      </div>
    </section>
  );
}
